import React, { useState } from 'react';
import styles from './index.module.scss';
import QRCode from "react-qr-code";
import {message, Modal} from 'antd';
import copy from "copy-to-clipboard";
import {RightIcon, Step1Icon, Step2Icon, Step3Icon, Step4Icon} from "@/config/config";
import host from "@/utils/host";
import AppCommonModal from "@/components/AppCommonModal";
import Image from "next/image";
import useLanguage from "@/hooks/useLanguage";
import { Trans } from 'react-i18next';

const AddShowCaseStepModal = ({ visible, link,  onCancel, productIds}) => {
  const {t, showcaseBanner} = useLanguage();

  const onCopy = () =>{
    window.gtag && window.gtag('event', 'copy_link', {
      'event_category': t('product_modal.ga_event_category'),
      'event_label': t('product_modal.ga_event_label'),
    });
    copy(getLink());
    message.success(t('product_modal.copy_success'));
  };

  const getLink = () =>{
    if (window) {
      // const href = window.location.origin + `${host}/api/v1/product/getQrUrl`;
      const href = link;
      const params = {
        productIds:productIds
      };

      const queryString = new URLSearchParams(params).toString();
      const newGetRequestUrl = `${href}?${queryString}`;
      return newGetRequestUrl;
    }
    return "";
  };

  return (
    <AppCommonModal
      show={visible}
      onCancel={onCancel}
      width={633}
      title={t('product_modal.method1')}
    >
      <div className={styles.customModal}>
        <div className={"mb-10 text-sm mt-[14px]"}>
          <Trans i18nKey='product_modal.scan_qr'>
            Use <span className={"high_light font-bold"}>TikTok</span> or <span className={"high_light font-bold"}>mobile Apps</span> to scan the QR code to get free sample.
          </Trans>
        </div>
        <div className={styles.content}>
          <div className={styles.qr_wrap}>
            <QRCode
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={getLink()}></QRCode>
          </div>
        </div>
        <p className={styles.title}>{t('product_modal.method2')}</p>
        <div className={styles.footer}>
          <div className={"mb-3"}>
            <Trans i18nKey='product_modal.copy_link'>
              Copy the link below to open it in your <span className={"high_light font-bold"}>mobile browser</span> to add to showcase.
            </Trans>
          </div>
          <div className={"flex items-center min-h-[52px] justify-center rounded bg-color8"}>
            <div
              style={{
                overflowWrap: 'break-word',
                wordBreak: 'break-word', // 确保长单词也能换行
                whiteSpace: 'normal', // 确保文本可以换行
              }}
              className={"px-3 break-words text-sm text-color2 leading-1.1"}>
              {getLink()}
            </div>
            <Image width={26} height={26} alt={""} className={"cursor-pointer mr-3 shrink-0 w-6 h-6"} onClick={onCopy} src='/images/showcase-copy-icon.png' style={{marginLeft: '20px'}}/>
          </div>
        </div>

        <div className={"bg-[#EDEDED] h-[1px] w-full my-6"}>
        </div>

        <p className={`${styles.title} text-color5`}>{t('product_modal.how_to_make_money')}</p>
        <div className={"w-full bg-[#F0774A0F] p-2 rounded"}>
          <Image width={1486} height={236} className={"w-full"} src={showcaseBanner} alt={"step"}></Image>
        </div>
      </div>
    </AppCommonModal>
  );
};

export default AddShowCaseStepModal;

